import request from './api'

// 查询科目
export const FindSubject = (params, opts) =>
    request('/api-resource/cjdd-resources/resourses/get/material/catalog', params, opts);

// 根据科目查询题型
export const FindTypeBySubject = (params, opts) =>
    request('/api-resource/questionType/select', params, opts);   // params {id: ''}
// 查询题型 -- 标准模式
export const findTypeByModel = (params, opts) =>
  request('/api-resource/questionType/query', params, { ...opts, method: 'post' });

// 根据科目查询标签
export const FindLabel = (params, opts) =>
    request('/api-resource/question/findLabel', params, opts);   // params {id: ''}

// 根据科目id查询知识点
export const FindMaterials = (params, opts) =>
    request(`/api-resource/cjdd-resources/resourses/get/material/catalog/${params}`, opts);

// 查询试题数据
export const QueryTestData = (params, opts) =>
    request('/api-resource/question/select', params, {
        ...opts,
        method: 'post'
    });

// 修改试题
export const UpdateTestData = (params, opts) =>
    request('/api-resource/question/update', params, {
        ...opts,
        method: 'post'
    });
// 修改试题 标准
export const UpdateTestDataNoRole = (params, opts) =>
    request('/api-resource/question/updateNoRole', params, {
        ...opts,
        method: 'post'
    });


// 查询试题上的富文本（多步骤实操题具有）
export const findQuestionStep = (id) =>
  request('/api-resource/question/findQuestionStep?questionId='+ id);

// 修改试题上的富文本（多步骤实操题具有）
export const updateQuestionStepById = (params) =>
  request('/api-resource/question/updateQuestionStepById', params, {method: 'post'});

// 新增自定义标签
export const InsertLable = (params, opts) =>
    request('/api-resource/question/insertLable', params, {
        ...opts,
        method: 'post'
    });

// 删除自定义标签
export const DeleteLable = (params, opts) =>
    request('/api-resource/question/deleteLable', params, {
        ...opts,
        method: 'post'
    });

// 删除试题
export const DeleteTestData = (params, opts) =>
    request('/api-resource/question/delete', params, opts);   // params {id: ''}

// 查询事项
export const QueryMatters = (params, opts) =>
    request('/api-resource/eventTemplate', params, opts);   // params {id: ''}
    // if (pageSize) {
    //     return axios.get(`/api-resource/eventTemplate?pageNum=1&pageSize=${pageSize}&eventType=1`);
    // } else {
    //     return axios.get(`/api-resource/eventTemplate?pageNum=1&eventType=1`);
    // }

// 查询科目下的公司
export const FindCompanyBySubjectId = (params, opts) =>
    request('/api-resource/company/query/by/lable', params, {
        ...opts,
        method: 'post'
    });

// 查询科目下的岗位
export const FindStationBySubjectId = (params, opts) =>
    request(`/api-resource/station/${params}`, opts);

// 删除附件
export const DeleteAttachment = (params, opts) =>
    request('/api-resource/question/deleteAttachment', params, opts);   // params {id: ''}

/*--------- 2022/5/12 添加 -----------*/
/*
  原知识点 更名 分类，现知识点接口，结构类似技能点
*/
// 获取知识点
export const findKnowledgeBySubjectId= (id, params, opts) =>
  request("/api-resource/knowledge/findKnowledgeBySubjectId/" +
    id,
    params,
    opts
  );
// 获取技能点
export const getSubjectSkill= (id, params, opts) =>
  request("/api-resource/skill/get/skill/subject/" +
    id,
    params,
    opts
  );

// 根据科目id查询技能点
export const FindSkills = (params, opts) =>
  request(`/api-resource/skill/get/skill/subject/${params}`, opts);

export const QueryTestDataById = (params, opts) =>
  request('/api-resource/question/select', params, {
    ...opts,
    method: 'post'
  });
export const findQuestionByPage = (params, opts) =>
  request('/api-resource/question/findQuestionByPage', params, {
    ...opts,
    method: 'post'
  });

//获取科目下的工作流
export const GetSubjectJobList = (id, params, opts) =>
  request("/api-resource/taskFlow/find/" + id,
    params,
    opts
  );

// 根据id查询试题详情
export const QueryQuestionById = (params, opts) =>
  request(`/api-resource/question/getById/${params}`, opts);   // params {id: ''}

// 添加试题
export const AddTestData = (params, opts) =>
  request('/api-resource/question/insert', params, {
    ...opts,
    method: 'post'
  });
// 添加试题 标准模式
export const AddTestDataNoRole = (params, opts) =>
  request('/api-resource/question/insertNoRole', params, {
    ...opts,
    method: 'post'
  });

// 复制试题
export const CopyTestData = (params, opts) =>
  request('/api-resource/question/copy', params, {
    ...opts,
    method: 'post'
  });
// 复制试题 -- new
export const CopyTestDataList = (params, opts) =>
  request('/api-resource/question/copyList', params, {
    ...opts,
    method: 'post'
  });

// 批量删除试题
export const RemoveAll = (params, opts) =>
  request('/api-resource/question/removeAll', params, {
    ...opts,
    method: 'post'
  });

// 试题解密
export const QuestionDecryption = (params, opts) =>
  request('/api-resource/testPaper/questionDecryption', params, { ...opts, method: 'post' });
// 操作记录
export const FindOperationRecordByQuestionId = (params, opts) =>
  request('/api-resource/question/findOperationRecordByQuestionId', params, { ...opts, method: 'get' });

// 根据科目查询默认分类 >>新加
export const getMaterialBySubjectId = (params, opts) =>
  request(`/api-resource/cjdd-resources/resourses/getMaterialBySubjectId/${params}`, opts);

// 课程库保存资源接口：
export const AddResource = (params, opts) =>
  request('/api-course/categoryResource/add/resource', params, {
    ...opts,
    method: 'post'
  });

// 试题收藏
export const addCollection = (params, opts) =>
  request('/api-course/userQuestionCollection/addCollection', params, {
    ...opts,
    method: 'post'
  });

// 课程库修改资源接口：
export const updateQuestion = (params, opts) =>
  request('/api-course/categoryResource/updateQuestion', params, {
    ...opts,
    method: 'post'
  });

// 试题导入预览
export const importPreview = (params, opts) =>
  request('/api-resource/question/importPreview', params, {
    ...opts,
    method: 'post'
  });
// 试题导入 重复检查
export const importCheck = (params, opts) =>
  request('/api-resource/question/importCheck', params, {
    ...opts,
    method: 'post'
  });
// 试题导入 保存
export const saveQuestionsData = (params, opts) =>
  request('/api-resource/question/questions-data-save', params, {
    ...opts,
    method: 'post'
  });

//查询当前用户可用的科目
export const getSubjectData = (params, opts) => request("/api-resource/cjdd-resources/currentUserPermission/subjects", params, opts);
//根据课程id获 获取该专业下的课程
export const getCourseList = (params, opts) => request("/api-course/course/querySameProfession", params, opts);
// 根据试题categoryResourceId 查询试题资源分类
export const queryCategoryResourceIdById = (params, opts) => request('/api-course/categoryResource/queryCategoryResourceIdById', params, opts);



// WEBPACK FOOTER //
// ./src/api/questionApi.js